import { useLanguage } from "../i18n/LanguageContext";

export const AmbientStatus = ({ className = "" }) => {
  const { lang } = useLanguage();
  return (
    <span
      aria-hidden="true"
      className={`pointer-events-none absolute z-0 flex items-center gap-1.5 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-teal-400/40 ${className}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="ping-slow absolute inline-flex h-full w-full rounded-full bg-teal-400/70" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-teal-400/70" />
      </span>
      {lang === "cs" ? "Systém online" : "System online"}
    </span>
  );
};
